import { AlertType } from '../components/alertComponent';
import {
  Hasura_Legal_Document_Types_Enum,
  Legal_Document_Types_Enum,
  UserAgreementTypes,
} from '../graphql/generated/hasura';
import { Enum_Legaldocument_Legaldocumenttype } from '../graphql/generated/strapi';

export const NOTIFICATION_TYPE_API = {
  INFO: 1,
  WARNING: 2,
  POSITIVE: 3,
  FAILURE: 4,
};

export const ALERT_TYPE_BY_NOTIFICATION_TYPE: Record<string, AlertType> = {
  [NOTIFICATION_TYPE_API.INFO]: 'info-blue',
  [NOTIFICATION_TYPE_API.WARNING]: 'info',
  [NOTIFICATION_TYPE_API.POSITIVE]: 'success',
  [NOTIFICATION_TYPE_API.FAILURE]: 'warning',
};

export const convertType = {
  [Legal_Document_Types_Enum.BaaAgreement]:
    Hasura_Legal_Document_Types_Enum.BaaAgreement,
  [Legal_Document_Types_Enum.CancellationPolicy]:
    Hasura_Legal_Document_Types_Enum.CancellationPolicy,
  [Legal_Document_Types_Enum.DnaVisitRecordConsent]:
    Hasura_Legal_Document_Types_Enum.DnaVisitRecordConsent,
  [Legal_Document_Types_Enum.GeneralTestRecordConsent]:
    Hasura_Legal_Document_Types_Enum.GeneralTestRecordConsent,
  [Legal_Document_Types_Enum.CoppaAgreement]:
    Hasura_Legal_Document_Types_Enum.CoppaAgreement,
  [Legal_Document_Types_Enum.HippaAgreement]:
    Hasura_Legal_Document_Types_Enum.HippaAgreement,
  [Legal_Document_Types_Enum.LabSampleResultsPrivacyStatement]:
    Hasura_Legal_Document_Types_Enum.LabSampleResultsPrivacyStatement,
  [Legal_Document_Types_Enum.NoticeOfPrivacy]:
    Hasura_Legal_Document_Types_Enum.NoticeOfPrivacy,
  [Legal_Document_Types_Enum.PrivacyPolicy]:
    Hasura_Legal_Document_Types_Enum.PrivacyPolicy,
  [Legal_Document_Types_Enum.ProviderDataUserAgreement]:
    Hasura_Legal_Document_Types_Enum.ProviderDataUserAgreement,
  [Legal_Document_Types_Enum.TermsOfService]:
    Hasura_Legal_Document_Types_Enum.TermsOfService,
};

export const providerConvertType = {
  [UserAgreementTypes.Baa]: Enum_Legaldocument_Legaldocumenttype.BaaAgreement,
  [UserAgreementTypes.Hippa]:
    Enum_Legaldocument_Legaldocumenttype.HippaAgreement,
  [UserAgreementTypes.PrivacyPolicy]:
    Enum_Legaldocument_Legaldocumenttype.PrivacyPolicy,
  [UserAgreementTypes.TermsOfService]:
    Enum_Legaldocument_Legaldocumenttype.TermsOfService,
} as Record<string, Enum_Legaldocument_Legaldocumenttype>;
